<template lang="html">
  <transition
    v-if="modalOpen"
    name="modal"
  >
    <div
      v-tracking-context="{page_type: webtrekkPageType}"
      class="registration-fence"
    >
      <div
        :class="contentClasses"
      >
        <component
          :is="modalComponent"
          v-bind="modalProps"
          @close="modalClose"
        >
          <template v-slot:default="slotProps">
            <a
              v-click-track="slotProps.clickTrack || {event_element: 'button', action_type: 'close'}"
              class="registration-fence__close"
              @click="modalClose"
            >
              <svg-icon icon-name="close-light" />
            </a>
          </template>
        </component>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Modal',
  props: {
    webtrekkPageType: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState(['modalOpen', 'modalComponent', 'modalProps']),
    contentClasses () {
      return {
        'registration-fence__content': true,
        'registration-fence__content--no-padding': this.modalProps && !!this.modalProps.modalNoPadding
      }
    }
  },
  methods: {
    ...mapMutations(['modalClose'])
  }
}
</script>

<style lang='scss' scoped>
  .registration-fence,
  .registration-fence__content {
    transition-duration: .3s;
  }

  .modal-enter,
  .modal-leave-to {
    opacity: 0;

    .registration-fence__content {
      transform: scale(1.1);
    }
  }
</style>
